<template>
  <div>
    {{ label }}
    <v-list-item-action
      v-if="showAction"
      class="ma-0"
    >
      <w-delete-button
        :title="$t('Common.remove')"
        :outlined="false"
        icon
        @click="$emit('removeFile', file)"
      />
    </v-list-item-action>
    <v-list-item-action
      v-if="showAction && (file.data.exists || file.isNew)"
      class="ma-0"
    >
      <w-download-button @click="$emit('downloadFile', file)">
        <template #tooltip>
          {{ $t('Components.sentences.downloadDocument') }}
        </template>
      </w-download-button>
    </v-list-item-action>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'UploadZoneFileItem',
  props: {
    file: { type: Object, required: true },
    readonly: { type: Boolean, default: false },
    userHasEditFileRight: { type: Boolean, default: false }
  },
  setup(props) {
    const label = computed(() => {
      return (
        props.file?.data?.originalName +
        ' (' +
        props.file?.data?.size / 1000 +
        ' KB)'
      );
    });

    const showAction = computed(() => {
      return !props.readonly && props.userHasEditFileRight;
    });

    return {
      label,
      showAction
    };
  }
};
</script>